export enum SetFilterAction {
  RESET = 'RESET',
  CHANGE = 'CHANGE'
}